import { ArcButton, ArcStack } from "@src/core/ui";
import React from "react";
import { NoFlySections } from "./components/Sections/no-fly";
// SAFE_LAND_DISABLED (2026-05): hidden per PM request. To restore: uncomment imports + JSX block + tab handlers below.
// import { ArcTab, ArcTabContext, ArcTabPanel, ArcTabs } from "@src/core/ui";
// import { useState } from "react";
// import { useSearchParams } from "react-router-dom";
// import { SafeLandSections } from "./components/Sections/safe-land";
// import { setHoveredSafeLandZoneId, useGetSafeLandZonesQuery } from '@src/features/zones/redux';
// import { setHoveredNoFlyZoneId } from '@src/core/features/zones/redux';
// import { safeLandZoneToZoneEntity } from "@src/features/zones/utils";
// import { VARIANT_SAFE_LAND } from "./types";
import { useNavigate } from "react-router-dom";
import { selectSelectedZone } from '@src/features/zones/redux';
import { useDispatch, useSelector } from "react-redux";
import { useGetZonesQuery, ZoneEntity, ZoneType } from "@src/core/features";
import { selectMapCenter, selectMapLocation, setMapCenter } from "@src/core/controllers";
import { VARIANT_NO_FLY, ZoneVariant } from "./types";
import { ZoneDetailsPopup } from "../../components/zone-details-popup";

// SAFE_LAND_DISABLED (2026-05): To restore: uncomment.
// const TAB_PARAM = "tab" as const;

export const ZonesPage: React.FC = () => {
  // SAFE_LAND_DISABLED (2026-05): tab state and ArcTabs UI are hidden; only no-fly is shown.
  // To restore: bring back useState<ZoneVariant>, useSearchParams handling, ArcTabs, ArcTabPanel for safe-land.
  // const [searchParams, setSearchParams] = useSearchParams();
  // const tabFromQuery = searchParams.get(TAB_PARAM) as ZoneVariant | null;
  // const [tab, setTab] = useState<ZoneVariant>(() => {
  //   if (tabFromQuery === VARIANT_SAFE_LAND || tabFromQuery === VARIANT_NO_FLY) {
  //     return tabFromQuery;
  //   }
  //   return VARIANT_NO_FLY;
  // });
  const tab: ZoneVariant = VARIANT_NO_FLY;

  const dispatch = useDispatch();
  const { data: zones } = useGetZonesQuery();
  // SAFE_LAND_DISABLED (2026-05): To restore: uncomment.
  // const { data: safeLandZones } = useGetSafeLandZonesQuery();
  // const safeLandZonesAsZones = (safeLandZones ?? []).map(safeLandZoneToZoneEntity);
  const mapLocation = useSelector(selectMapLocation);
  const mapCenter = useSelector(selectMapCenter);

  const getSortedZones = (type: ZoneType) =>
    zones
      ?.filter((z) => z.zoneType === type)
      .sort((a, b) => {
        if (a.isActive && !b.isActive) return -1;
        if (!a.isActive && b.isActive) return 1;
        if (a.isActive && b.isActive) {
          return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
        }
        if (!a.isActive && !b.isActive) {
          return new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime();
        }
        return 0;
      });

  const temporaryZones = getSortedZones(ZoneType.TEMPORARY);
  const permanentZones = getSortedZones(ZoneType.PERMANENT);

  const navigate = useNavigate();
  const selectedZone = useSelector(selectSelectedZone);

  // SAFE_LAND_DISABLED (2026-05): handleTabChange not needed with a single visible tab.
  // To restore: uncomment along with the ArcTabs JSX block.
  // const handleTabChange = (_e: React.SyntheticEvent, value: string) => {
  //   const next = value as ZoneVariant;
  //   setTab(next);
  //   if (next === VARIANT_NO_FLY) {
  //     dispatch(setHoveredSafeLandZoneId(null));
  //   }
  //   if (next === VARIANT_SAFE_LAND) {
  //     dispatch(setHoveredNoFlyZoneId(null));
  //   }
  //   if (searchParams.has(TAB_PARAM)) {
  //     setSearchParams(
  //       (params) => {
  //         const next = new URLSearchParams(params);
  //         next.delete(TAB_PARAM);
  //         return next;
  //       },
  //       { replace: true }
  //     );
  //   }
  // };

  const centerMapOnZoneLocation = () => {
    const center = mapLocation
      ? { lat: mapLocation.latitude, lng: mapLocation.longitude }
      : mapCenter;
    dispatch(setMapCenter(center));
  };

  const handleCreateNoFly = () => {
    centerMapOnZoneLocation();
    navigate("create");
  };

  // SAFE_LAND_DISABLED (2026-05): To restore: uncomment.
  // const handleCreateSafeLand = () => {
  //   centerMapOnZoneLocation();
  //   navigate("create-safe-land");
  // };

  return (
    <React.Fragment>
      {/* SAFE_LAND_DISABLED (2026-05): tabs hidden per PM request.
          To restore: wrap the ArcStack below in:
            <ArcTabContext value={tab}>
              <ArcTabs value={tab} onChange={handleTabChange} variant="fullWidth"
                       TabIndicatorProps={{ sx: { bgcolor: 'brand.main' } }}>
                <ArcTab value={VARIANT_NO_FLY} label="No-fly" />
                <ArcTab value={VARIANT_SAFE_LAND} label="Safe-land" />
              </ArcTabs>
              <ArcTabPanel value={VARIANT_NO_FLY} sx={{ p: 0 }}> ...no-fly content... </ArcTabPanel>
              <ArcTabPanel value={VARIANT_SAFE_LAND} sx={{ p: 0 }}>
                <ArcStack marginTop={4} spacing={5}>
                  <ArcButton.brand onClick={handleCreateSafeLand} sx={{ px: 2, py: 1 }}>
                    Create Safe-land Zone
                  </ArcButton.brand>
                  <SafeLandSections safeLandZones={safeLandZonesAsZones} />
                </ArcStack>
              </ArcTabPanel>
            </ArcTabContext>
      */}
      <ArcStack marginTop={4} spacing={2}>
        <ArcButton.brand onClick={handleCreateNoFly} sx={{ px: 2, py: 1 }}>
          Create No-fly Zone
        </ArcButton.brand>
        <NoFlySections temporaryZones={temporaryZones} permanentZones={permanentZones} />
      </ArcStack>
      <ZoneDetailsPopup zone={selectedZone as ZoneEntity} variant={tab} />
    </React.Fragment>
  );
};
